import React, { createContext, useReducer } from 'react';
import {
  UPDATE_PAPER_WIDTH,
  UPDATE_PAPER_HEIGHT,
  UPDATE_BORDER,
  UPDATE_PAPER_WIDTH_PX,
  UPDATE_PAPER_HEIGHT_PX,
  UPDATE_GRID_SIZE,
  UPDATE_GRID,
  UPDATE_FIT_IMAGE,
  UPDATE_GRAYSCALE,
  TOGGLE_SETTINGS,
  SET_IMAGE,
  UPDATE_GRID_COLOR,
  UPDATE_GRID_SECOND,
  UPDATE_GRID_SIZE_SECOND,
  UPDATE_GRID_COLOR_SECOND,
  UPDATE_PAPER_LAYOUT,
  SET_ALLOW_DRAG,
  SET_IMAGE_SCALE,
  SET_PICKED_COLOR,
  SET_PICKING_COLOR,
  SET_SHOW_GRID_LABELS,
  SET_IMAGE_DOWNLOADING,
  SET_IMAGE_DOWNLOADED,
  ADD_REFERENCE_COLOR,
  ADD_COLOR_GROUP,
  SET_SHOW_COLOR_PALETTE,
  SET_SHOW_SAVE_MODAL,
  SET_SHOW_LOAD_MODAL,
  SET_REFERENCE_COLORS,
} from './types';

const initialState = {
  image: '',
  // image:
  //   'https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.blastr.com%2Fsites%2Fblastr%2Ffiles%2Fstar-wars-han-solo.jpeg&f=1&nofb=1',
  paperWidth: 26,
  paperHeight: 36,
  paperLayout: 'landscape',
  border: 1,
  paperWidthPx: 0,
  paperHeightPx: 0,
  grid: false,
  gridSize: 2,
  gridColor: '#000',
  gridSecond: false,
  gridSizeSecond: 1,
  gridColorSecond: '#FFF',
  stretchImage: true,
  grayscale: false,
  showingSettings: false,
  showGridLabels: false,
  allowDrag: false,
  pickingColor: false,
  pickedColor: '',
  scale: 1,
  imageDownloading: false,
  imageDownloaded: false,
  referenceColors: [],
  colorGroups: [],
  showColorPalette: false,
  showSaveModal: false,
  showLoadModal: false,
};

const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }) => {
  const [storeState, dispatch] = useReducer((state, action) => {
    const { type, payload } = action;
    switch (type) {
      case UPDATE_PAPER_WIDTH:
        return { ...state, paperWidth: payload };
      case UPDATE_PAPER_HEIGHT:
        return { ...state, paperHeight: payload };
      case UPDATE_PAPER_LAYOUT:
        return { ...state, paperLayout: payload };
      case UPDATE_BORDER:
        return { ...state, border: payload };
      case UPDATE_PAPER_WIDTH_PX:
        return { ...state, paperWidthPx: payload };
      case UPDATE_PAPER_HEIGHT_PX:
        return { ...state, paperHeightPx: payload };
      case UPDATE_GRID:
        return { ...state, grid: payload };
      case UPDATE_GRID_SIZE:
        return { ...state, gridSize: payload };
      case UPDATE_GRID_COLOR:
        return { ...state, gridColor: payload };
      case UPDATE_GRID_SECOND:
        return { ...state, gridSecond: payload };
      case UPDATE_GRID_SIZE_SECOND:
        return { ...state, gridSizeSecond: payload };
      case UPDATE_GRID_COLOR_SECOND:
        return { ...state, gridColorSecond: payload };
      case SET_SHOW_GRID_LABELS:
        return { ...state, showGridLabels: payload };
      case UPDATE_FIT_IMAGE: {
        let allowDrag = state.allowDrag;
        if (payload === false) allowDrag = false;
        return { ...state, stretchImage: payload, allowDrag };
      }
      case UPDATE_GRAYSCALE:
        return { ...state, grayscale: payload };
      case TOGGLE_SETTINGS:
        return { ...state, showingSettings: payload || !state.showingSettings };
      case SET_IMAGE:
        return { ...state, image: payload };
      case SET_PICKING_COLOR: {
        let allowDrag = state.allowDrag;
        if (payload === true) allowDrag = false;
        return { ...state, pickingColor: payload, allowDrag };
      }
      case SET_PICKED_COLOR: {
        let pickingColor = state.pickingColor;
        if (pickingColor) pickingColor = false;
        return { ...state, pickedColor: payload, pickingColor };
      }
      case SET_ALLOW_DRAG:
        return { ...state, allowDrag: payload };
      case SET_IMAGE_SCALE:
        return { ...state, scale: payload };
      case SET_IMAGE_DOWNLOADING:
        return { ...state, imageDownloading: payload };
      case SET_IMAGE_DOWNLOADED:
        return { ...state, imageDownloaded: payload };
      case ADD_REFERENCE_COLOR:
        return {
          ...state,
          referenceColors: [...state.referenceColors, payload],
        };
      case SET_REFERENCE_COLORS:
        return { ...state, referenceColors: payload };
      case ADD_COLOR_GROUP:
        return {
          ...state,
          colorGroups: [...state.colorGroups, payload],
        };
      case SET_SHOW_COLOR_PALETTE:
        return { ...state, showColorPalette: payload };
      case SET_SHOW_SAVE_MODAL:
        return { ...state, showSaveModal: payload };
      case SET_SHOW_LOAD_MODAL:
        return { ...state, showLoadModal: payload };
      default:
        return state;
    }
  }, initialState);

  return <Provider value={{ ...storeState, dispatch }}>{children}</Provider>;
};

export { store, StateProvider };
